"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCooldownForSpeed = void 0;
// todo tune this
const getCooldownForSpeed = (speed) => Math.ceil((180 - speed) / 24);
exports.getCooldownForSpeed = getCooldownForSpeed;
